import { render } from "./UtilFonds.vue?vue&type=template&id=553da6fc"
import script from "./UtilFonds.vue?vue&type=script&lang=js"
export * from "./UtilFonds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__